// Small, failure-tolerant wrappers for lightweight browser storage. Only UI
// preferences and layout live here; chat and assistants are wallet-owned server records.

const PREFIX = 'kumio.';

export const local = {
  get<T>(key: string, fallback: T): T {
    try {
      const v = localStorage.getItem(PREFIX + key);
      return v == null ? fallback : (JSON.parse(v) as T);
    } catch {
      return fallback;
    }
  },
  set(key: string, value: unknown): boolean {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },
  del(key: string) {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      /* storage blocked */
    }
  },
  keys(): string[] {
    try {
      return Object.keys(localStorage).filter((k) => k.startsWith(PREFIX));
    } catch {
      return [];
    }
  },
  clearAll() {
    for (const k of this.keys()) {
      try {
        localStorage.removeItem(k);
      } catch {
        /* ignore */
      }
    }
  },
};

export const session = {
  get(key: string): string | null {
    try {
      return sessionStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string) {
    try {
      sessionStorage.setItem(PREFIX + key, value);
    } catch {
      /* ignore */
    }
  },
};
